import { render, staticRenderFns } from "./WinningScientificCompetitionCard.vue?vue&type=template&id=0c75f594&scoped=true"
import script from "./WinningScientificCompetitionCard.vue?vue&type=script&lang=js"
export * from "./WinningScientificCompetitionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75f594",
  null
  
)

export default component.exports